import type { LayoutNode } from '@vedalib/editor'
import { produce } from 'immer'
import { useEffect, useState } from 'react'

import { updateNodeState } from 'services/Store/Project/actions'
import type { AppMode } from 'services/Store/Project/enums'
import { useProjectDispatch } from 'services/Store/Project/hooks'
import type { IBlockMode } from 'services/Store/Project/types'

export const useCustomMode = (mode: IBlockMode, node: LayoutNode, isActive: boolean) => {
  const dispatch = useProjectDispatch()
  const [editorMode, setEditorMode] = useState<AppMode | null>(null)
  const nextMode = produce(mode, (draft) => {
    if (editorMode) {
      draft.editorMode = editorMode
    }
  })

  useEffect(() => {
    setEditorMode(null)
  }, [isActive, mode])

  useEffect(() => {
    if (!isActive) {
      dispatch(updateNodeState({ id: node.id, state: { isEditingGrid: false, transform: null } }))
    }
  }, [dispatch, isActive, node.id])

  return [nextMode, setEditorMode] as const
}
